export class ConveyanceResponse {
  ConveyanceID: number;
  Name: string;
  From: string;
  To: string;
  Active: boolean;
  Description: string;
}
